import React from "react";
import { useTranslation } from "react-i18next";

const Login = () => {
  const { t } = useTranslation();
  const handleInstall = () => {
    const base = (import.meta.env.VITE_BACKEND_URL || "").replace(/\/$/, "");
    window.location.href = base ? `${base}/install` : "/install";
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <img src="/img/bulkeditpro-long.webp" alt="BulkEditPro Logo" style={{ width: '200px', height: 'auto' }} />
        <h1>{t("login.title")}</h1>
        <p>{t("login.subtitle")}</p>
        <button className="install-button" onClick={handleInstall}>
          {t("login.installApp")}
        </button>
      </div>
    </div>
  );
};

export default Login; 